/**
 * BulkActionBar — the morph toolbar shown when one or more students
 * are selected (issue #436 acceptance criterion #6).
 *
 * Renders inline inside CaseloadToolbar on both desktop and mobile.
 * When `selectedCount === 0` the parent doesn't render this at all,
 * so the value is guaranteed ≥ 1 here.
 */
import type { ReactElement } from 'react';

export interface BulkActionBarProps {
  selectedCount: number;
  onArchive: () => void;
  onCancel: () => void;
  /** Disable the archive button while the RPC is in flight. */
  archiving?: boolean;
}

export function BulkActionBar({
  selectedCount,
  onArchive,
  onCancel,
  archiving = false,
}: BulkActionBarProps): ReactElement {
  return (
    <div
      className="caseload-bulk"
      role="toolbar"
      aria-label="Bulk caseload actions"
    >
      <span className="caseload-bulk-count" aria-live="polite">
        {selectedCount} selected
      </span>
      <button
        type="button"
        className="caseload-bulk-archive"
        onClick={onArchive}
        disabled={archiving}
      >
        {archiving ? 'Archiving…' : 'Archive selected'}
      </button>
      <button
        type="button"
        className="caseload-bulk-cancel link-button"
        onClick={onCancel}
      >
        Cancel
      </button>
    </div>
  );
}
